import React, { useContext, useEffect, useState } from "react";
import useGetChapters from "../hooks/useGetChapters";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { ChevronUpIcon } from "@heroicons/react/24/solid";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import ChapterAccordions from "../components/Home/ChapterAccordion";
import YoutubeModal from "../components/Home/YoutubeModal";
import { useLocation, useNavigate } from "react-router-dom";
import useGetTopics from "../hooks/useGetTopics";
import { AppsContext } from "../context/AppsContext";
import { queryType } from "../firestore/basicOperations";


const Home = ({ isSub }: { isSub?: boolean }) => {

    const { app, chapters, setChapters, topics, setTopics } = useContext(AppsContext);
    console.log(app);

    const { getChaptersList, chaptersList, loading: chapterLoading } = useGetChapters();
    const { getTopicsList, topicsList, loading: topicsLoading } = useGetTopics();

    const [accordion, setAccordion] = useState("");
    const [selectedLanguage, setSelectedLanguage] = useState<"English" | "Kannada">("English")
    const [youtubeModal, setYoutubeModal] = useState<boolean>(false);
    const navigate = useNavigate();
    useEffect(() => {
        if (app?.id) {
            const queryList: queryType = [["language", "==", selectedLanguage], ["appId", "==", app.id]];
            if (app.type === 2) {
                queryList.push(["grade", "==", app.class]);
            }
            getChaptersList(queryList);
        }
    }, [selectedLanguage, app]);

    useEffect(() => {
        if (chapterLoading === false) {
            if (chaptersList === "Not Subscribed!") {
                setChapters(chaptersList);
                navigate("/checkout")
            } else {
                const chapterIds = chaptersList.map((chapter) => chapter.id);
                getTopicsList([["chapterId", "in", chapterIds]])
                setChapters(chaptersList);
            }
        }
    }, [chaptersList]);

    useEffect(() => {
        if (topicsLoading === false) {
            setTopics(topicsList);
        }
    }, [topicsLoading]);

    let classWidth: string | undefined;
    if (isSub) {
        classWidth = "w-full"
    } else {
        classWidth = "w-10/12 sm:w-6/12"
    }

    return (
        <div className={`flex flex-col w-[100vw] items-center gap-1 ${isSub}?"":"mt-[10vh]" bg-customBg h-[90vh] overflow-auto`}>
            <YoutubeModal visible={youtubeModal} onClose={() => setYoutubeModal(false)} />
            <div className={`${classWidth}  ${isSub} && flex gap-2 mt-4 justify-between mb-2 `}>
                <button className="inline-flex items-center px-4 py-2 rounded-md bg-slate-300 text-nowrap"
                    onClick={() => setYoutubeModal(true)}
                >How to use <QuestionMarkCircleIcon className="size-5" /></button>
                <div className={` dark:text-gray-800 inline-flex`}>
                    <button className={`px-4 py-2 rounded-l-md ${selectedLanguage === "English" ? "dark:bg-slate-300" : "dark:bg-gray-200"} cursor-pointer font-semibold`} onClick={() => setSelectedLanguage("English")}>English</button>
                    <button className={`px-4 py-2 rounded-r-md ${selectedLanguage !== "English" ? "dark:bg-slate-300" : "dark:bg-gray-200"} cursor-pointer font-semibold`} onClick={() => setSelectedLanguage("Kannada")}>ಕನ್ನಡ</button>
                </div>
            </div>
            {
                (chapterLoading || chapters === "Not Subscribed!") ? "Loading..." : chapters?.sort((a, b) => a.chapter_id - b.chapter_id).map((doc: any, index: number) => {
                    const docData = doc;
                    return (
                        <div key={docData.chapter_id} className={classWidth}>
                            <div className="flex border border-borderColor rounded-md justify-between items-center p-4  bg-white cursor-pointer shadow-xl text-xl" onClick={() => {
                                if (accordion === docData.id) {
                                    setAccordion("")
                                } else {
                                    setAccordion(docData.id)
                                }
                            }} >
                                <div className="font-bold text-ellipsis overflow-hidden ...">
                                    {index + 1}. {docData.name}
                                </div>
                                {accordion === docData.id ? <ChevronUpIcon className="size-5" /> : <ChevronDownIcon className="size-5" />}
                            </div>
                            <div className={`grid shadow-slate-200 shadow-inner overflow-hidden transition-all duration-300 ease-in-out cursor-pointer text-slate-950 ${accordion === docData.id ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                                <ChapterAccordions topicsList={topics.filter((topics) => topics.chapterId === docData.id)} docData={docData ? docData : {}} kannada={selectedLanguage === "Kannada" ? true : false} />
                            </div>
                        </div>
                    )
                })
            }
        </div>)
}

export default React.memo(Home);